import { render } from "./ITCGridComponent.vue?vue&type=template&id=250c92cc"
import script from "./ITCGridComponent.vue?vue&type=script&lang=js"
export * from "./ITCGridComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__